import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import './App.css';

import Register from './layouts/Register/Register';
import Home from './layouts/Home/Home';
import Setting from './layouts/Setting/Setting';
import Privacy from './layouts/Privacy/Privacy';
import Duties from './layouts/Duties/Duties';
import Event from './layouts/Event/Event';
import Reminder from './layouts/Reminder/Reminder';
import Year from './layouts/Year/Year';


class App extends Component {
  render() {
    return (
      <div className="App" id="app">
        <Router>
          <Switch>
            <Route path="/register">
              <Register />
            </Route>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/setting">
              <Setting />
            </Route>
            <Route path="/privacy">
              <Privacy />
            </Route>
            <Route path="/reminder">
              <Reminder />
            </Route>
            <Route path="/task">
              <Duties />
            </Route>
            <Route path="/event">
              <Event />
            </Route>
            <Route path="/year">
              <Year />
            </Route>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
